import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";

const LINKS = [
  { to: "/about", label: "About Us" },
  { to: "/for-business", label: "List your business" },
  { to: "/legal/privacy", label: "Privacy Policy" },
  { to: "/legal/terms", label: "Terms of Service" },
  { to: "/legal/security", label: "Trust Center" },
  { to: "/contact", label: "Contact" },
];

function TikTok({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={`${className} fill-current`} aria-hidden="true">
      <path d="M16.6 5.82a4.28 4.28 0 0 1-3.14-1.4V15.5a4.9 4.9 0 1 1-4.9-4.9c.16 0 .32 0 .48.03v2.5a2.4 2.4 0 1 0 1.71 2.3V2h2.4a4.28 4.28 0 0 0 3.45 4.2v2.3a6.7 6.7 0 0 1-1.6-.2v3.06a6.7 6.7 0 0 0 1.6.2v-5.74z" />
    </svg>
  );
}

const SOCIALS = [
  { href: "https://www.instagram.com/shuwa.app", label: "Instagram", Icon: Instagram },
  { href: "https://www.tiktok.com/@shuwa.app", label: "TikTok", Icon: TikTok },
  { href: "https://www.linkedin.com/company/shuwa-app/", label: "LinkedIn", Icon: Linkedin },
];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-6 border-b border-white/10 px-4 py-6 sm:px-6">
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm">
          {LINKS.map((link) => (
            <Link key={link.to} to={link.to} className="text-slate-400 transition hover:text-white">
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/download"
            className="flex items-center gap-2 rounded-xl border border-white/15 bg-black px-3.5 py-2 transition hover:border-white/40"
          >
            <svg viewBox="0 0 384 512" className="h-6 w-6 fill-white" aria-hidden="true">
              <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141 0 184.8 0 273.5c0 26.2 4.8 53.3 14.4 81.2 12.8 37.5 59 129.3 107.2 127.8 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-84.1 102.6-121.7-65.2-30.7-57.7-90-57.7-92.1zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
            </svg>
            <span className="text-left leading-tight">
              <span className="block text-[9px] uppercase tracking-wide text-slate-400">Download on the</span>
              <span className="block text-sm font-semibold text-white">App Store</span>
            </span>
          </Link>
          <Link
            to="/download"
            className="flex items-center gap-2 rounded-xl border border-white/15 bg-black px-3.5 py-2 transition hover:border-white/40"
          >
            <svg viewBox="0 0 512 512" className="h-6 w-6 fill-white" aria-hidden="true">
              <path d="M47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.6 28.5 21.7 35.3l256.6-256L47 0zm278.3 234.3L104.6 13l280.8 161.2-60.1 60.1zm0 43.4l60.1 60.1L104.6 499l220.7-221.3zm146.9-93.2l-58.9-34.1-65.7 64.5 65.7 64.5 60-34.1c18-14.3 18-46.5-1.1-60.8z" />
            </svg>
            <span className="text-left leading-tight">
              <span className="block text-[9px] uppercase tracking-wide text-slate-400">Get it on</span>
              <span className="block text-sm font-semibold text-white">Google Play</span>
            </span>
          </Link>
        </div>
      </div>

      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-6 sm:px-6">
        <div className="flex items-center gap-2">
          <span className="text-lg font-bold text-white">SHUWA</span>
          <span className="text-xs text-slate-500">
            © {new Date().getFullYear()} SHUWA. All rights reserved.
          </span>
        </div>
        <div className="flex items-center gap-3">
          {SOCIALS.map(({ href, label, Icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="flex h-9 w-9 items-center justify-center rounded-full border border-white/20 text-slate-300 transition hover:border-white/40 hover:text-white"
            >
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
